"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiBackdrop = void 0;
var styles_1 = require("@material-ui/core/styles");
var palette_1 = require("../../../theme/global/palette");
exports.MuiBackdrop = {
    root: {
        backgroundColor: (0, styles_1.alpha)(palette_1.palette.common.black, 0.3),
    },
};
